import * as React from 'react'

import { baseApiUrl } from 'embed/constants/config'

interface Props {
  leadUuid?: string
  rateTableUuid?: string
  offerUuid: string
}

const TrackingPixel = ({ leadUuid, rateTableUuid, offerUuid }: Props) => {
  if (!leadUuid || !rateTableUuid) {
    return null
  }
  const src = `${baseApiUrl}/uiEvent/offerDisplays/${leadUuid}/${rateTableUuid}/${offerUuid}/pixel.gif`
  return <img src={src} style={{ display: 'none' }} />
}

export default TrackingPixel
